import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminOverview from "./AdminOverview";
import UserManagement from "./UserManagement";
import TransactionManagement from "./TransactionManagement";
import BalanceManagement from "./BalanceManagement";
import WalletManagement from "./WalletManagement";
import KYCManagement from "./KYCManagement";
import MessageManagement from "./MessageManagement";
import UserWalletManagement from "./UserWalletManagement"; // Add this import
import CryptoBalanceManagement from "./CryptoBalanceManagement";

const AdminDashboard = () => {
  return (
    <div className="space-y-6">
      <Routes>
        <Route index element={<AdminOverview />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="transactions" element={<TransactionManagement />} />
        <Route path="balances" element={<BalanceManagement />} />
        <Route path="crypto-balances" element={<CryptoBalanceManagement />} />
        <Route path="wallets" element={<WalletManagement />} />
        <Route path="user-wallets" element={<UserWalletManagement />} />
        <Route path="kyc" element={<KYCManagement />} />
        <Route path="messages" element={<MessageManagement />} />
      </Routes>
    </div>
  );
};

export default AdminDashboard;
